import { useMediaQuery } from "@mui/material";
import { CallLogsDispositions, LeadData, Status } from "types";
import { Button, Label, Modal, Textarea } from 'flowbite-react';
import Select, { SingleValue } from 'react-select';
import { useGetAllLeadGenUsers, useReassignLeadGenPOC } from "src/hooks/leadGen.hooks";
import { useEffect, useState } from "react";
import { useToast } from "src/context/ToastProvider";

type Props = {
    selectedleadGen: string;
    isOpen: boolean;
    onClose: () => void;
    refetch?: () => void;
    selectedData: LeadData;
    setIsReassignLeadGenPOCModal: (value: boolean) => void;
    bulkSelectedIds: string[];
};

const ReassignLeadGenPOCModal = ({
    isOpen, onClose, selectedleadGen, selectedData, refetch, bulkSelectedIds
}: Props) => {
    const toast = useToast();
    const isMobile = useMediaQuery('(max-width:960px)');
    const { data: allLeadGensUser } = useGetAllLeadGenUsers();
    const [formData, setFormData] = useState<{ leadGenPOC: string }>({ leadGenPOC: selectedData?.leadGenPOC || '' });

    const { mutate: reassignLeadGenPOC, isLoading } = useReassignLeadGenPOC(
        data => {
            toast({ title: 'Lead Gen POC reassigned successfully', type: 'success' });
            onClose();
            refetch?.();
        },
        error => {
            toast({ title: error?.message || 'Error reassigning Lead Gen POC', type: 'error' });
        }
    );
    
    const handleSubmit = () => {
        if (!formData.leadGenPOC) {
            toast({ title: 'Please select a Lead Gen POC', type: 'error' });
            return;
        }

        reassignLeadGenPOC({ leadId: bulkSelectedIds.length > 0 ? bulkSelectedIds : selectedleadGen, newPocId: formData.leadGenPOC });
    };

    return (
        <Modal show={isOpen} size="xl" onClose={onClose} dismissible>
            <Modal.Header>
                <h1 className="text-[#1C1C28] dark:text-inherit text-xl md:text-2xl font-inter font-[500]">Reassign Lead Gen POC</h1>
            </Modal.Header>
            <Modal.Body className="overflow-visible">
                <div className='flex flex-col gap-2'>
                    <div>
                        <Label>{'Lead Gen POC'}</Label>
                        <span className="text-red-600 pl-1">*</span>
                    </div>
                    <Select
                        instanceId="leadGenPOC"
                        menuPlacement={'auto'} // Adjust placement if needed
                        classNamePrefix="my-select-plans"
                        name="leadGenPOC"
                        className="single-value-select-tag mt-1"
                        options={allLeadGensUser?.data
                            ?.filter((user: any) => user._id !== selectedleadGen)
                            ?.map((user: any) => ({
                                label: user.name || '',
                                value: user._id,
                            })) || []
                        }
                        placeholder="Select new Lead Gen POC"
                        value={formData.leadGenPOC ? {
                            label: allLeadGensUser?.data?.find((user: any) => user._id === formData.leadGenPOC)?.name || formData.leadGenPOC,
                            value: formData.leadGenPOC
                        } : null}
                        onChange={(newValue) => {
                            if (newValue) {
                                setFormData(prevData => ({
                                    ...prevData,
                                    leadGenPOC: newValue.value,
                                }));
                            }
                        }}
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 9999, // Ensure dropdown is above other elements
                            }),
                        }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className='flex justify-end'>
                <Button
                    color="gray"
                    onClick={onClose}
                    className="mr-2"
                >
                    Cancel
                </Button>
                <Button
                    color="purplePlaced"
                    onClick={handleSubmit}
                    isProcessing={isLoading}
                    disabled={formData.leadGenPOC === selectedData?.leadGenPOC || !formData.leadGenPOC}
                >
                    Reassign
                </Button>
            </Modal.Footer>
        </Modal>

    )
}

export default ReassignLeadGenPOCModal;